module.exports = __webpack_public_path__ + "img/AR.1b145e05.svg";